module.exports = __webpack_public_path__ + "static/media/westhill-scenic.1118b0d3.jpg";